import type { ResponseError } from 'superagent';
import client from 'api/client';
import taxonomy from 'api/definitions/taxonomy';
import env from 'env/env';
import { log } from 'utils/error-logging';

import {
  FAILED,
  FOOTER_FAILED,
  FOOTER_LOADED,
  FOOTER_LOADING,
  LOADED,
  LOADING,
} from 'redux/modules/taxonomy/actions/types';
import { TAXONOMY_FULL_DEPTH } from 'constants/taxonomy';

export function getTaxonomy() {
  return (dispatch: WtrDispatch) =>
    dispatch({
      types: [LOADING, LOADED, FAILED] as const,
      depth: TAXONOMY_FULL_DEPTH,
      apiCall: taxonomy.get({
        retry: {
          numberOfRetries: 1,
        },
      }),
    });
}

export function fetchFooter() {
  return {
    types: [FOOTER_LOADING, FOOTER_LOADED, FOOTER_FAILED] as const,
    callback: {
      failure: (err: ResponseError) => {
        if (err.status || err.timeout) {
          log(`Footer fetch failed! ${err}`, { logger: 'footer-fetcher' });
        }
      },
    },
    // Public CDN: bypasses apiCallback so no JWT or cookies are sent
    apiCall: () =>
      client({
        method: 'get',
        url: `${env.cfDomain}/content/waitrosegroceriescms/en/common/site-footer.json.html`,
        withCredentials: false,
        // Ignore any Set-Cookie from the CDN
        cookieHandler: () => undefined,
        memoryCacheKey: 'footer',
        memoryCacheMaxAge: 300000,
      }),
  };
}
